<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  metaInfo: {
    title: 'App',
    titleTemplate: '%s — opTV.nu'
  },
  computed: {
    ...mapState(['firebaseUser'])
  }
}
</script>

<style>
  .fade-enter-active {
    transition: opacity 0.5s;
  }
  .fade-leave-active {
    transition: opacity 0s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue